/* import __COLOCATED_TEMPLATE__ from './suggestion-details-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

interface Signature {
  Args: {
    taskSuggestion: TaskSuggestion;
    mockConversations: any;
  };
}

export default class SuggestionDetailsPanel extends Component<Signature> {
  @tracked isContextOpen = true;
  @tracked isConversationsOpen = true;
  @tracked isTopicsOpen = true;

  get contextIcon() {
    return this.isContextOpen ? 'double-chevrons' : 'double-chevrons-right';
  }

  get conversationsIcon() {
    return this.isConversationsOpen ? 'double-chevrons' : 'double-chevrons-right';
  }

  get topicsIcon() {
    return this.isTopicsOpen ? 'double-chevrons' : 'double-chevrons-right';
  }

  @action
  toggleContext(): void {
    this.isContextOpen = !this.isContextOpen;
  }

  @action
  toggleConversations(): void {
    this.isConversationsOpen = !this.isConversationsOpen;
  }

  @action
  toggleTopics(): void {
    this.isTopicsOpen = !this.isTopicsOpen;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionDetailsPanel': typeof SuggestionDetailsPanel;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-details-panel': typeof SuggestionDetailsPanel;
  }
}
